import React, { useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import './QRCodeGenerator.css';

const QRCodeGenerator = ({ zone, onClose }) => {
  const qrCodeRef = useRef(null);

  // Create URL for the QR code that includes the zone ID
  const zoneUrl = `${window.location.origin}/zone?zone=${zone.code}`;
  
  const downloadQRCode = () => {
    if (!qrCodeRef.current) return;
    
    const svg = qrCodeRef.current.querySelector('svg');
    if (!svg) return;
    
    // Convert SVG to data URL
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL('image/png');
      
      // Create download link and trigger download
      const downloadLink = document.createElement('a');
      downloadLink.download = `zone-${zone.code}-qrcode.png`;
      downloadLink.href = pngFile;
      downloadLink.click();
    };
    img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)));
  };

  return (
    <div className="qr-code-modal">
      <div className="qr-code-container">
        <div className="qr-code-header">
          <h3>QR Code for {zone.name}</h3>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        
        <div className="qr-code-content">
          <div className="qr-code" ref={qrCodeRef}>
            <QRCodeSVG
              value={zoneUrl}
              size={200}
              level="H"
              includeMargin={true}
              imageSettings={{
                src: "/favicon.svg",
                excavate: true,
                height: 24,
                width: 24,
              }}
            />
          </div>
          
          <div className="qr-code-info">
            <p>Zone: <strong>{zone.name} ({zone.code})</strong></p>
            <p>URL: <a href={zoneUrl} target="_blank" rel="noopener noreferrer">{zoneUrl}</a></p>
          </div>
          
          <div className="qr-code-actions">
            <button 
              className="download-button"
              onClick={downloadQRCode}
            >
              Download QR Code
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRCodeGenerator; 